import React from "react";
import ConnectionDetails from "./ConnectionDetails";
import ConnectionDataService from "../../services/connection.service";
import SignupDataService from "../../services/signup.service";
import Button from "react-bootstrap/Button";
import './Connection.css';
import EmailDataService from "../../services/email.service";

class Connection extends React.Component{
  
    constructor(props) {
        super(props);
        const isLoggedIn = window.localStorage.getItem("userid") ? true : false;
        this.handleAccept = this.handleAccept.bind(this);
        this.handleReject = this.handleReject.bind(this);
        let userid = 0;
        //this.openConnection = this.openConnection.bind(this);
        //this.openOtherConnection = this.openOtherConnection.bind(this);
        this.close = this.close.bind(this);
        if(isLoggedIn)
        {
        userid = window.localStorage.getItem("userid");
    
        }
        this.state = {
            userid: userid,
            connectionList: [],
            connectionInterestList: [],
            displayUser : 0,
            displayEmail: '',
            isApprover : 0
        };
      }

      openConnection(name, value, email) {
         SignupDataService.get(parseInt(value))
         .then(res => {
            if(res.data != "")
            {
                this.setState({displayUser: parseInt(value)});
                this.setState({displayEmail: res.data.email});
                this.setState({isApprover: 0}); 
            }

         })

  
      }


      handleAccept(event) {

        event.preventDefault();

      }

      handleReject(event) {

        event.preventDefault();

      }


      close(event) {

        event.preventDefault();
        this.setState({displayUser: 0});
        this.setState({isApprover: 0});
        this.setState({connectionList: []});
        this.setState({connectionInterestList: []});
        //pull fresh data back from the database
        this.componentDidMount();


      }


     

      openOtherConnection(name, value) {
     
        this.setState({displayUser: parseInt(value)});
        this.setState({isApprover: 1});
        
        

      }

      componentDidMount() {

        ConnectionDataService.getAll(parseInt(this.state.userid))
        .then(response => {

            response.data.map(connections => {
                //console.log(connections.status);
                //Get the profile of the user you show interest for.

                SignupDataService.get(parseInt(connections.interestuserid))
                .then(response1 => {

                    let status = "Pending";

                    if(parseInt(connections.status) === 1)
                    {
                        status = "Pending";
                    }
                    else if(parseInt(connections.status) === 2)
                    {
                        status = "Has Accepted";
                    }
                    else if(parseInt(connections.status) === 4)
                    {
                        status = "No Interest";
                    }
                    else
                    {
                        status = "Has Rejected. Sorry.";
                    }
                    let email = '';
                    if(parseInt(connections.status) == 2)
                    {
                        email = response1.data.email;
                    }
                    var data = {
                        id: connections.id,
                        interestuserid: connections.interestuserid,
                        name: response1.data.name,
                        age: response1.data.age,
                        status: status,
                        email: email
                    }

                    this.setState({
                        connectionList: [
                        ...this.state.connectionList,
                         data
                        ]
                      }); 


                });

                
            
            }
    
                )

        });


        ConnectionDataService.getAllInterests(parseInt(this.state.userid))
        .then(response => {
           
            response.data.map(connections => {

                SignupDataService.get(parseInt(connections.userid))
                .then(response2 => {

                    let status = "Pending";
        
                    if(parseInt(connections.status) == 1)
                    {
                        status = "Pending";
                    }
                    else if(parseInt(connections.status) == 2)
                    {
                        status = "You Accepted";
                    }
                    else
                    {
                        status = "You Rejected";
                    }

                    var data = {
                        id: connections.userid,
                        interestuserid: connections.interestuserid,
                        name: response2.data.name,
                        age: response2.data.age,
                        status: status
                    }

                    this.setState({
                        connectionInterestList: [
                        ...this.state.connectionInterestList,
                         data
                        ]
                      })  

                })
   
                 
            }
    
                )

        });



      }


      render(){

        return (
            <div  className="Login">
                <div className="Row col-md-12">
                    <b>Once the interested party accepts your interest, You will receive their email address, so you may contact them.</b>
                </div>

                <div className="col-md=12">
                    {
                        this.state.displayUser > 0 ? <ConnectionDetails onClose={this.close} isApprover={this.state.isApprover} interestemail={this.state.displayEmail} interestuserid={this.state.displayUser} /> : '' 
                    }
                </div>

                <div  className="row col-md-12 header-boundaries">
                    <div className="col-md-12 title-header"><b>Outgoing Requests</b></div>
                  {this.state.connectionList.length > 0 ?
                  <div>

                    <table responsive className="table">
                    <thead>
                        <tr><td>Name</td>
                        <td>Age</td>
                        <td>Status</td>
                        <td>Email(if accepted)</td>
                        <td></td>
                        </tr>
                    </thead>
                   <tbody>
                    {

                    this.state.connectionList.map((connection,index) => (
                        <tr>
                        <td key={index + "_a"} className="table-text-color">{connection.name}</td>  
                        <td key={index + "_b"} className="table-text-color">{connection.age}</td>  
                        <td key={index + "_c"} className="table-text-color">{connection.status}</td>  
                        <td key={index + "_z"} className="table-success-color">{connection.email}</td>  
                        <td>
                        <Button style={{cursor:'pointer'}}   onClick={e => this.openConnection(e.target.value, connection.interestuserid)} className="btn btn-success">Details</Button>
                        </td>
                      </tr>
                                   
                    ))
                    }
                    </tbody>
                     </table>



                  </div>
                  : 
                  <div className="row col-md-10 offset-2 color-table">No outgoing requests sent</div>
                  }
                    
                </div>
                <div className="row col-md-12 header-boundaries">
                <div className="col-md-12 title-header"><b>Incoming  Requests</b></div>


                {this.state.connectionInterestList.length > 0 ?
                <div>
                        <table className="table">
                    <thead>
                        <tr><td>Name</td>
                        <td>Age</td>
                        <td>Status</td>
                        <td> </td>
                        </tr>
                    </thead>
                   <tbody>
                    {

                    this.state.connectionInterestList.map((connection,index) => (
                                <tr>
                                      <td key={index + "_d"}><span className="table-text-color">{connection.name}</span></td>  
                                      <td key={index + "_e"} className="table-text-color">{connection.age}</td>  
                                      <td key={index + "_f"} className="table-text-color">{connection.status}</td>  
                                     <td><Button style={{cursor:'pointer'}}  onClick={e => this.openOtherConnection(e.target.value, connection.id)}  className="btn btn-success">Details</Button></td>
                                    </tr>

                    ))
                    }
                    </tbody>
                     </table>

                    </div>
                :   <div className="row col-md-10 offset-2 color-table">No Incoming requests sent</div>}
                
               

                </div>
            </div>
        )

      }
}
 
export default Connection;